module.exports = __webpack_public_path__ + "static/media/uit_logo.png.3c62c839.webp";